import { Field } from 'formik';
import React, { memo } from 'react';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';

const TextField = () => {
  return <Field multiline id='observation' name='observation' fullWidth placeholder='Comentário' component={TextFormField} />;
};

export default memo(TextField);
